// extracted by mini-css-extract-plugin
export default {"texts__input":"TextsInputs_texts__input__wmK7V","textarea__input":"TextsInputs_textarea__input__us7Up"};